import {GenderType, ProfileUser, ProfileViewProps} from './types';

/**
 * function prepare and return data for profile view
 * @param {GenderType} gender
 * @return {string | undefined}
 */
export function getGenderLabel(gender: GenderType | string | undefined)
  : string | undefined {
  switch (gender) {
    case GenderType.Male:
      return 'Мужской';
    case GenderType.Female:
      return 'Женский';
  }
}

/**
 * function prepare and return data for profile view
 * @param {ProfileUser} user
 * @return {any}
 */
export function prepareProfileData(user: ProfileUser): ProfileViewProps {
  const emptyValue = '';

  return {
    name: user.name,
    surname: user.surname || emptyValue,
    gender: user.gender,
    nickname: user.nickname,
    avatar: user.avatar,
    video: user.video || emptyValue,
    contacts: {
      email: user.contacts?.email || emptyValue,
      phone: user.contacts?.phone || emptyValue,
    },
    socials: {
      instagram: user.socials?.instagram || emptyValue,
      vkontakte: user.socials?.vkontakte || emptyValue,
      telegram: user.socials?.telegram || emptyValue,
    },
    preferredCommunication: user?.preferredCommunication,
    info: {
      about: user.info?.about || emptyValue,
      birthday: user.info?.birthday,
      city: user.info?.city || emptyValue,
      education: user.info?.education || emptyValue,
      job: user.info?.job || emptyValue,
    },
  };
}
